// Custom hook for search functionality

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { searchAPI } from '../api/search';
import toast from 'react-hot-toast';
import {
  setSearchResults,
  clearSearch,
  addRecentSearch,
  selectSearchResults,
  selectHasSearched,
  selectRecentSearches,
  DEFAULT_SEARCH_FILTERS
} from '../store/searchSlice';

const hasActiveFilters = (filters) =>
  Object.keys(DEFAULT_SEARCH_FILTERS).some((key) => filters[key] !== DEFAULT_SEARCH_FILTERS[key]);

export const useSearch = () => {
  const dispatch = useDispatch();
  const results = useSelector(selectSearchResults);
  const hasSearched = useSelector(selectHasSearched);
  const recentSearches = useSelector(selectRecentSearches);
  // Transient - deliberately not persisted, a stale "loading" state on
  // return to the page would be wrong.
  const [isSearching, setIsSearching] = useState(false);

  const search = async (filters) => {
    setIsSearching(true);

    try {
      const searchResults = await searchAPI.searchAll(filters);
      dispatch(setSearchResults(searchResults));

      if (hasActiveFilters(filters)) {
        dispatch(addRecentSearch({ filters, resultCount: searchResults.length }));
      }

      if (searchResults.length === 0) {
        toast('No results found', { icon: 'ℹ️' });
      } else {
        toast.success(`Found ${searchResults.length} result(s)`);
      }
    } catch (error) {
      console.error('Search error:', error);
      toast.error('Search failed. Please try again.');
      dispatch(setSearchResults([]));
    } finally {
      setIsSearching(false);
    }
  };

  const clearResults = () => {
    dispatch(clearSearch());
  };

  return {
    results,
    isSearching,
    hasSearched,
    recentSearches,
    search,
    clearResults
  };
};
